import PropTypes from 'prop-types';

import { Typography } from '@mui/joy';

import Handlebars from 'handlebars'
import { createContext } from 'react';
import { useContext } from 'react';
import { FeatureCard } from '../FeatureCard';
import { Link } from 'react-router-dom';
import { Books } from '@phosphor-icons/react';

export const ContentBlockContext = createContext({
    data: null,
    setData: () => {}
})
  
function formatHTML(value, data) {
    let html = value
    const template = Handlebars.compile(value)
    html = template(data)
    html = html?.replace(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/, (url) => {
        return `<iframe frameborder="0" style="width: 100%; aspect-ratio: 16/9"  src="https://youtube.com/embed/${url.split('=')[1]}"></iframe>`
    })
    html = html?.replace(
        /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi,
        (email) => `<a href="mailto:${email}">${email}</a>`
    )

    return html
}

export function ParagraphBlock({
    content,
}) {
    return (
       <>
        {content?.map(block => <Block key={block.id} {...block} />)}
       </>
    )
}

ParagraphBlock.propTypes = {
    content: PropTypes.array.isRequired
}

export function TextBlock({
    value,
    ...props
}) {
    const { data } = useContext(ContentBlockContext);
    console.log("label", data.label)
    return (
        <p {...props} dangerouslySetInnerHTML={{ __html: formatHTML(value, data) }} />
    )
}

TextBlock.propTypes = {
    value: PropTypes.string.isRequired
}

export function LinkBlock({
    reference
}) {
    const { data } = useContext(ContentBlockContext);
    console.log("label", data.label)

    return (
        <FeatureCard
            sx={{ marginBottom: 1, p: 1 }}
            as={Link}
            name={reference.name}
            Icon={Books}
            to={`/dashboard/docs/${reference.slug}`}
        />
    )
}

LinkBlock.propTypes = {
    nodeType: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    reference: PropTypes.object.isRequired
}

export function PageBlock({
    name,
    content,
    ...props
}) {
    if (!(content instanceof Array)) {
        return <></>
    }

    return (
        <article {...props}>
            <Typography level="h2" component="h2">{name}</Typography>
            {content?.map(block => <Block key={block.id} {...block} {...block.content} />)}
        </article>
    )
}

PageBlock.propTypes = {
    nodeType: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    content: PropTypes.array.isRequired
}

export function DocumentBlock({
    content,
    ...props
}) {
    return (
        <article {...props}>
            {content?.map(block =><Block key={block.id} {...block} />)}
        </article>
    )
}

DocumentBlock.propTypes = {
    nodeType: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    content: PropTypes.array.isRequired
}

export function Block({
    nodeType,
    ...props
}) {
    switch (nodeType) {
        case "document":
            return (
                <DocumentBlock {...props} nodeType={nodeType} />
            )
        case "paragraph":
            return (
                <ParagraphBlock {...props} nodeType={nodeType} />
            )
        case "text":
            return (
                <TextBlock {...props} nodeType={nodeType} />
            )
        case "blockLink":
        case "link":
            return (
                <LinkBlock {...props} nodeType={nodeType} />
            )
    }
}

Block.propTypes = {
    nodeType: PropTypes.string.isRequired
}